var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"sm":"12"}},[_c('i',{staticClass:"fa fax fa-spinner fa-spin fa-3x fa-fw",attrs:{"aria-hidden":"true"}}),_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }